import type { ReactNode } from "react";

export interface KeyValueItem {
  key: string;
  label: ReactNode;
  value: ReactNode;
}

export function KeyValueGrid({ items }: { items: KeyValueItem[] }) {
  return (
    <dl className="kv-grid" style={{ margin: 0 }}>
      {items.map((it) => (
        <div key={it.key} className="kv">
          <dt className="kv__k">{it.label}</dt>
          <dd className="kv__v" style={{ margin: 0 }}>
            {it.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
